import { Reveal } from "./Weave";

const QUESTIONS = [
  "Is your expertise, credibility, reputation still opening doors?",
  "Has something shifted — in you, and in how others see you?",
  "Are colleagues questioning your commitment to the job?",
  "Is your age a silent barrier to progress?",
  "Is AI devaluing your experience rather than recognising it?",
];

export default function Challenge() {
  return (
    <section id="shift" data-testid="empathy-section" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8 lg:py-32">
        <Reveal>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-wred">The shift</p>
          <h2 className="max-w-3xl text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
            What&rsquo;s your future looking like?
          </h2>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-body2">
            If any of these land a little too close to home, you&rsquo;re in good company. Most of the
            people we work with felt exactly this before they gave themselves permission to explore.
          </p>
        </Reveal>

        <div className="mt-14">
          {QUESTIONS.map((q, i) => (
            <Reveal key={i} delay={i * 0.06} y={18}>
              <div className="group flex items-baseline gap-6 border-b border-ink/10 py-6 transition-all duration-300 hover:border-tealb/60 sm:gap-10 sm:py-8">
                <span className="text-sm font-bold tabular-nums text-tealb sm:text-base">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-xl font-medium leading-snug text-ink transition-all duration-300 group-hover:translate-x-2 group-hover:text-tealdark sm:text-2xl lg:text-3xl">
                  {q}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 rounded-3xl border-l-8 border-wyellow bg-yellowlight p-8 sm:p-12">
            <p className="text-2xl font-bold leading-snug text-ink sm:text-3xl">
              You&rsquo;re not in crisis. But you&rsquo;re paying attention.
            </p>
            <p className="mt-5 max-w-3xl text-lg leading-relaxed text-body2">
              The real question is whether you act now — while you have the resources, the energy, and
              the freedom to choose — or later, when those choices are made for you. We think
              you&rsquo;re here because you&rsquo;d rather be the one deciding.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
